<template>
  <header class="site-header">
    <div class="header-inner">
      <a class="wordmark" href="#top" aria-label="Erdem Karataş — home">
        erdem<span>karataş.</span>
      </a>
      <button class="menu-button" type="button" :aria-expanded="menuOpen" aria-controls="primary-navigation" @click="menuOpen = !menuOpen">
        {{ menuOpen ? 'CLOSE' : 'MENU' }}
      </button>
      <nav id="primary-navigation" :class="['navigation', { open: menuOpen }]" aria-label="Primary navigation">
        <a href="#work" @click="closeMenu">01 / Work</a>
        <a href="#lab" @click="closeMenu">02 / Lab</a>
        <a href="#experience" @click="closeMenu">03 / Experience</a>
        <a class="nav-contact" href="#contact" @click="closeMenu">Let's talk ↗</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() { return { menuOpen: false }; },
  methods: { closeMenu() { this.menuOpen = false; } }
};
</script>

<style scoped>
.site-header {
  position: sticky;
  z-index: 100;
  top: 0;
  border-bottom: var(--line);
  background: rgba(238, 233, 220, 0.94);
  backdrop-filter: blur(8px);
}

.header-inner {
  width: var(--page);
  height: 76px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wordmark {
  color: var(--ink);
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 900;
  letter-spacing: -0.085em;
  line-height: 1;
  text-decoration: none;
}

.wordmark span { font-weight: 400; }

.navigation {
  display: flex;
  align-items: center;
  gap: clamp(20px, 3vw, 48px);
  font-family: "Courier New", monospace;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.navigation a { position: relative; text-decoration: none; }

.navigation a:not(.nav-contact)::after {
  position: absolute;
  right: 0;
  bottom: -5px;
  left: 0;
  height: 2px;
  background: var(--ink);
  content: '';
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 180ms ease;
}

.navigation a:hover::after { transform: scaleX(1); transform-origin: left; }

.nav-contact {
  padding: 10px 13px;
  border: var(--line);
  background: var(--red);
  box-shadow: 3px 3px 0 var(--ink);
  color: #fff;
}

.nav-contact:hover { box-shadow: 1px 1px 0 var(--ink); transform: translate(2px, 2px); }

.menu-button {
  display: none;
  padding: 8px 10px;
  border: var(--line);
  background: var(--yellow);
  color: var(--ink);
  font-family: "Courier New", monospace;
  font-size: 0.8rem;
  font-weight: 700;
}

@media (max-width: 760px) {
  .header-inner { height: 62px; }
  .menu-button { display: block; }
  .navigation {
    position: absolute;
    top: 62px;
    right: -2px;
    left: -2px;
    display: none;
    align-items: stretch;
    gap: 0;
    border: var(--line);
    border-top: 0;
    background: var(--paper-light);
  }
  .navigation.open { display: flex; flex-direction: column; }
  .navigation a { padding: 17px 20px; border-bottom: 1px solid var(--ink); }
  .navigation a:last-child { border-bottom: 0; }
  .nav-contact { border: 0; box-shadow: none; }
}
</style>
